import * as R from 'remeda'

import { type FiveSegmentCounts, fiveSegments } from '~/utils'

import {
  calcFiveSegmentIndicatorCounts,
  type FiveSegmentsData,
} from './fiveSegments'

export type FiveSegmentsDataInput = {
  fiveSegmentCounts: FiveSegmentCounts
  total: number
  // From useFiveSegmentsTotalData's counts.
  totalDataCounts: FiveSegmentsData['counts']
}

export const buildFiveSegmentsData = (
  input: FiveSegmentsDataInput,
): FiveSegmentsData => {
  const counts = {
    total: input.total,
    ...input.fiveSegmentCounts,
    ...calcFiveSegmentIndicatorCounts(input.fiveSegmentCounts),
  }
  const ratios = R.mapToObj(
    ['total', ...fiveSegments] as const,
    (indicator) => [
      indicator,
      counts[indicator] / input.totalDataCounts[indicator],
    ],
  )

  return {
    counts,
    ratios: {
      ...ratios,
      ...calcFiveSegmentIndicatorCounts(ratios),
    },
  }
}
